var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('div',[_c('a',{attrs:{"href":_vm.page.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.page.title))])]):_c('div',[_vm._v("Δεν έχει συνδεθεί σελίδα")])
}
var staticRenderFns = []

export { render, staticRenderFns }